import { createContext } from 'react';

const BrowserContext = createContext(null);

export default BrowserContext;
